import React from 'react'
import { Logo } from '../../assests/ExportImageIcon'
import './TrainSearchLoader.css'

const TrainIcon = () => (
    <svg width="250" height="56" viewBox="-8 -34 258 82" className='trainSearchLoader__trainSvg'>
        <defs>
            <linearGradient id="trainSearchLoaderEngineBody" x1="0" y1="0" x2="0" y2="34" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#2fb589" />
                <stop offset="0.5" stopColor="#0f6b4f" />
                <stop offset="1" stopColor="#0a4a39" />
            </linearGradient>
            <linearGradient id="trainSearchLoaderCoachBody" x1="0" y1="0" x2="0" y2="30" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#f6d276" />
                <stop offset="0.5" stopColor="#e2ab2f" />
                <stop offset="1" stopColor="#a97a0c" />
            </linearGradient>
            <linearGradient id="trainSearchLoaderGlass" x1="0" y1="0" x2="0" y2="10" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#eaf7f1" />
                <stop offset="1" stopColor="#96cdb5" />
            </linearGradient>
            <radialGradient id="trainSearchLoaderWheelShine" cx="35%" cy="30%" r="70%">
                <stop offset="0" stopColor="#5a5a5e" />
                <stop offset="1" stopColor="#1c1c1e" />
            </radialGradient>
        </defs>

        {/* coach 2 (rear) */}
        <g transform="translate(0,4)">
            <rect x="0" y="6" width="62" height="27" rx="4" fill="url(#trainSearchLoaderCoachBody)" />
            <rect x="0" y="6" width="62" height="4.5" fill="#8a5f0c" />
            <rect x="0" y="14" width="62" height="1.6" fill="#7a5b1f" opacity="0.5" />
            <rect x="5" y="16" width="10" height="10" rx="1.5" fill="url(#trainSearchLoaderGlass)" stroke="#7a5b1f" strokeWidth="0.8" />
            <rect x="19" y="16" width="10" height="10" rx="1.5" fill="url(#trainSearchLoaderGlass)" stroke="#7a5b1f" strokeWidth="0.8" />
            <rect x="37" y="12" width="13" height="20" rx="1.5" fill="#7a5b1f" opacity="0.9" />
            <rect x="39" y="14" width="9" height="7" rx="1" fill="url(#trainSearchLoaderGlass)" />
            <line x1="43.5" y1="21" x2="43.5" y2="32" stroke="#5c4310" strokeWidth="1" />
            <rect x="0" y="28" width="62" height="2.2" fill="#7a5b1f" opacity="0.6" />
            <rect x="57" y="25" width="6" height="3" fill="#333" />
        </g>

        {/* coach 1 */}
        <g transform="translate(64,2)">
            <rect x="0" y="6" width="62" height="29" rx="4" fill="url(#trainSearchLoaderCoachBody)" />
            <rect x="0" y="6" width="62" height="4.5" fill="#8a5f0c" />
            <rect x="0" y="14" width="62" height="1.6" fill="#7a5b1f" opacity="0.5" />
            <rect x="5" y="16" width="10" height="10" rx="1.5" fill="url(#trainSearchLoaderGlass)" stroke="#7a5b1f" strokeWidth="0.8" />
            <rect x="19" y="16" width="10" height="10" rx="1.5" fill="url(#trainSearchLoaderGlass)" stroke="#7a5b1f" strokeWidth="0.8" />
            <rect x="37" y="12" width="13" height="22" rx="1.5" fill="#7a5b1f" opacity="0.9" />
            <rect x="39" y="14" width="9" height="7" rx="1" fill="url(#trainSearchLoaderGlass)" />
            <line x1="43.5" y1="21" x2="43.5" y2="34" stroke="#5c4310" strokeWidth="1" />
            <rect x="0" y="30" width="62" height="2.2" fill="#7a5b1f" opacity="0.6" />
            <rect x="57" y="27" width="6" height="3" fill="#333" />
        </g>

        {/* engine (locomotive) */}
        <g transform="translate(122,0)">
            <rect x="10" y="33" width="14" height="5" rx="1" fill="#0a4a39" />
            <rect x="34" y="33" width="14" height="5" rx="1" fill="#0a4a39" />
            <rect x="58" y="33" width="14" height="5" rx="1" fill="#0a4a39" />

            <rect x="0" y="4" width="80" height="30" rx="3" fill="url(#trainSearchLoaderEngineBody)" />
            <path d="M80 4 Q106 5 112 17 Q106 29 80 34 Z" fill="url(#trainSearchLoaderEngineBody)" />
            <path d="M4 4 Q4 -2 10 -2 H72 Q78 -2 78 4 Z" fill="#0a4a39" />

            <line x1="30" y1="-2" x2="24" y2="-14" stroke="#333" strokeWidth="1.4" />
            <line x1="24" y1="-14" x2="40" y2="-14" stroke="#333" strokeWidth="1.4" />
            <line x1="40" y1="-14" x2="34" y2="-2" stroke="#333" strokeWidth="1.4" />
            <line x1="27" y1="-8" x2="37" y2="-8" stroke="#333" strokeWidth="1" />

            <rect x="50" y="-9" width="11" height="9" rx="2" fill="#0a4a39" />
            <circle cx="55.5" cy="-11" r="5" fill="#c3cac6">
                <animate attributeName="cy" values="-11;-34;-11" dur="1.2s" repeatCount="indefinite" />
                <animate attributeName="cx" values="55.5;62;55.5" dur="1.2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="1;0;1" dur="1.2s" repeatCount="indefinite" />
                <animate attributeName="r" values="3.6;11;3.6" dur="1.2s" repeatCount="indefinite" />
            </circle>
            <circle cx="55.5" cy="-11" r="4.6" fill="#d8ddda" opacity="0.95">
                <animate attributeName="cy" values="-11;-32;-11" dur="1.2s" begin="0.24s" repeatCount="indefinite" />
                <animate attributeName="cx" values="55.5;49;55.5" dur="1.2s" begin="0.24s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.95;0;0.95" dur="1.2s" begin="0.24s" repeatCount="indefinite" />
                <animate attributeName="r" values="3.4;10;3.4" dur="1.2s" begin="0.24s" repeatCount="indefinite" />
            </circle>
            <circle cx="55.5" cy="-11" r="4.2" fill="#c3cac6" opacity="0.9">
                <animate attributeName="cy" values="-11;-33;-11" dur="1.2s" begin="0.48s" repeatCount="indefinite" />
                <animate attributeName="cx" values="55.5;61;55.5" dur="1.2s" begin="0.48s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.9;0;0.9" dur="1.2s" begin="0.48s" repeatCount="indefinite" />
                <animate attributeName="r" values="3.2;9.5;3.2" dur="1.2s" begin="0.48s" repeatCount="indefinite" />
            </circle>
            <circle cx="55.5" cy="-11" r="3.8" fill="#e2e6e3" opacity="0.85">
                <animate attributeName="cy" values="-11;-31;-11" dur="1.2s" begin="0.72s" repeatCount="indefinite" />
                <animate attributeName="cx" values="55.5;50;55.5" dur="1.2s" begin="0.72s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.85;0;0.85" dur="1.2s" begin="0.72s" repeatCount="indefinite" />
                <animate attributeName="r" values="3;9;3" dur="1.2s" begin="0.72s" repeatCount="indefinite" />
            </circle>
            <circle cx="55.5" cy="-11" r="3.4" fill="#cfd6d3" opacity="0.8">
                <animate attributeName="cy" values="-11;-30;-11" dur="1.2s" begin="0.96s" repeatCount="indefinite" />
                <animate attributeName="cx" values="55.5;58;55.5" dur="1.2s" begin="0.96s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.8;0;0.8" dur="1.2s" begin="0.96s" repeatCount="indefinite" />
                <animate attributeName="r" values="2.8;8.5;2.8" dur="1.2s" begin="0.96s" repeatCount="indefinite" />
            </circle>

            <rect x="0" y="25" width="80" height="4" fill="#f0c04a" />
            <path d="M80 25 Q100 25.6 106 27 Q100 28.4 80 29 Z" fill="#f0c04a" opacity="0.9" />

            <text x="40" y="21" textAnchor="middle" fontFamily="Segoe UI, sans-serif" fontSize="7" fontWeight="700" letterSpacing="1" fill="#eafaf1" opacity="0.95">SAB RAAH</text>

            <rect x="7" y="9" width="14" height="11" rx="1.5" fill="url(#trainSearchLoaderGlass)" stroke="#0a4a39" strokeWidth="0.8" />
            <path d="M84 8 Q100 9 104 17 Q100 25 84 26 Z" fill="url(#trainSearchLoaderGlass)" opacity="0.95" />
            <line x1="94" y1="9.5" x2="94" y2="24.5" stroke="#0a4a39" strokeWidth="0.8" />

            <circle cx="108" cy="17" r="3" fill="#fff3c4">
                <animate attributeName="opacity" values="1;0.5;1" dur="1s" repeatCount="indefinite" />
            </circle>
            <circle cx="108" cy="17" r="5.5" fill="#fff3c4" opacity="0.25">
                <animate attributeName="opacity" values="0.25;0.05;0.25" dur="1s" repeatCount="indefinite" />
            </circle>

            <rect x="46" y="10" width="18" height="2.6" rx="1.3" fill="#0a4a39" opacity="0.75" />
            <rect x="46" y="15" width="18" height="2.6" rx="1.3" fill="#0a4a39" opacity="0.75" />
            <rect x="46" y="20" width="18" height="2.6" rx="1.3" fill="#0a4a39" opacity="0.75" />

            <rect x="-6" y="27" width="6" height="3" fill="#333" />
            <rect x="4" y="32" width="70" height="4" rx="1.5" fill="#0a4a39" />
        </g>

        {/* wheel bogies */}
        <g>
            <rect x="4" y="33" width="22" height="6" rx="2" fill="#141416" />
            <circle cx="10" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="10" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="9.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <circle cx="22" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="22" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="21.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <animateTransform attributeName="transform" type="rotate" additive="sum" from="0 16 42" to="360 16 42" dur="0.4s" repeatCount="indefinite" />
        </g>
        <g>
            <rect x="46" y="33" width="22" height="6" rx="2" fill="#141416" />
            <circle cx="52" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="52" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="51.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <circle cx="64" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="64" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="63.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <animateTransform attributeName="transform" type="rotate" additive="sum" from="0 58 42" to="360 58 42" dur="0.4s" repeatCount="indefinite" />
        </g>
        <g>
            <circle cx="146" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="146" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="145.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <animateTransform attributeName="transform" type="rotate" from="0 146 42" to="360 146 42" dur="0.4s" repeatCount="indefinite" />
        </g>
        <g>
            <circle cx="178" cy="42" r="6.6" fill="url(#trainSearchLoaderWheelShine)" />
            <circle cx="178" cy="42" r="2.6" fill="#c9c9c9" />
            <rect x="177.3" y="36" width="1.4" height="12" fill="#8a8a8e" />
            <animateTransform attributeName="transform" type="rotate" from="0 178 42" to="360 178 42" dur="0.4s" repeatCount="indefinite" />
        </g>
    </svg>
)

const TrainSearchLoader = ({ text = 'Booking Your Train', size = 'default' }) => {
    return (
        <div className={`trainSearchLoader ${size === 'compact' ? 'trainSearchLoader--compact' : ''}`}>
            <div className='trainSearchLoader__logoCircle'>
                <img src={Logo} alt='' />
            </div>

            <div className='trainSearchLoader__trackWrap'>
                <div className='trainSearchLoader__ballast' />
                <div className='trainSearchLoader__railTop' />
                <div className='trainSearchLoader__sleepers' />
                <div className='trainSearchLoader__railBottom' />
                <div className='trainSearchLoader__trainDrive'>
                    <TrainIcon />
                </div>
            </div>

            {text && (
                <p className='trainSearchLoader__text'>
                    {text}
                    <span className='trainSearchLoader__dots'>
                        <span>.</span><span>.</span><span>.</span>
                    </span>
                </p>
            )}
        </div>
    )
}

export default TrainSearchLoader
